import styles from "../dropdown.css.js";
import { DropdownLinksWhenAuthenticated } from "./DropdownLinksWhenAuthenticated.jsx";
import { DropdownLink } from "./DropdownLink.jsx";

/**
 * Renders a dropdown menu that dynamically displays links based on the authentication state.
 * If the user is authenticated, it shows authenticated links; otherwise, it shows a login link.
 *
 * @param {Object} props - The properties object.
 * @param {Object} props.data - The data object containing user information and linkHost URL.
 * @param {Function} props.close - Function to close the dropdown menu.
 * @param {boolean} props.withLogo - Indicates whether to display the logo alongside dropdown links.
 * @return {JSX.Element} A React component that renders the dropdown menu.
 */
export function OpenedDropdown({ data, close, withLogo }) {
  return (
    <div className={styles.dropdown({ withLogo: withLogo })}>
      {data.me ? (
        <DropdownLinksWhenAuthenticated
          withLogo={withLogo}
          me={data.me}
          close={close}
          linkHost={data.linkHost}
        />
      ) : (
        <DropdownLink
          to={`${data.linkHost || ""}/login`}
          close={close}
          isLast={true}
        >
          Login
        </DropdownLink>
      )}
    </div>
  );
}
